import { ImageDriver, imageDriverFactory } from './Image.driver';
import { dataHooks } from './constants';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ImagePrivateDriver extends ImageDriver {
  hasErrorMessage(): Promise<boolean>;
  hover(): Promise<void>;
}

export const imagePrivateDriverFactory = (
  base: UniDriver,
): ImagePrivateDriver => ({
  ...imageDriverFactory(base),

  hasErrorMessage: () =>
    base.$(`[data-hook="${dataHooks.errorMessageWrapper}"]`).exists(),
  hover: async () => base.hover(),
});
